export const WORKRAMP_ACADEMY = "WORKRAMP_ACADEMY";
export const AUTH_AND_EVAL = "AUTH_AND_EVAL";
export const TODDLE_LIBRARY = "TODDLE_LIBRARY";
export const TODDLE_AI = "TODDLE_AI";
export const AI_TUTOR = "AI_TUTOR";
export const TODDLE_ANALYTICS = "TODDLE_ANALYTICS";
export const ENGAGEMENT_ANALYTICS = "ENGAGEMENT";
export const PERFORMANCE_ANALYTICS = "PERFORMANCE";
export const BEHAVIOUR_ANALYTICS = "BEHAVIOUR";
export const MODULE_USAGE_ANALYTICS = "MODULE_USAGE";
export const ATTENDANCE_ANALYTICS = "ATTENDANCE";
export const WORKSHEET = "WORKSHEET";
export const WORKSHEET_AI = "WORKSHEET_AI";
export const AI_GRADING = "AI_GRADING";
export const UNIT_PLANNING_AI = "UNIT_PLANNING_AI";
export const IMPORT_UNIT_FROM_OTHER_CURRICULUM = "IMPORT_OTHER_CURRICULUM_UNIT";
export const WORKSHEET_BASIC = "WORKSHEET_BASIC";
export const WORKRAMP_ACADEMY_TYPE_CONFIG_ID = "71887912504923283";
export const MESSAGING = "MESSAGING";
export const ADD_ON_MANAGER = "ADD_ON_MANAGER";
export const CURRICULUM_PROGRAM = "CURRICULUM_PROGRAM";
export const GLOBAL = "GLOBAL";
export const ENABLE = "ENABLE";
export const DISABLE = "DISABLE";
export const USER = "USER";
export const ACADEMIC_YEAR_TRANSITION = "ACADEMIC_YEAR_TRANSITION";
export const ORGANIZATION = "ORGANIZATION";
export const ACTIVITY_TRACKER = "ACTIVITY_TRACKER";
export const BEHAVIOUR_MANAGEMENT = "BEHAVIOUR_MODULE";
export const STUDENT_PRONOUNS = "PRONOUNS";
export const IN_APP_TRANSLATION = "IN_APP_TRANSLATION";
export const DP_1_AND_DP_2_STUDENTS = "DP_1_AND_DP_2_STUDENTS";
export const IBIS_REGISTRATION_REVAMP = "IBIS_REGISTRATION_REVAMP";
export const ADD_ADMIN_TO_ALL_CLASSES = "ADD_ADMIN_TO_ALL_CLASSES";
export const CROSS_CURRICULUM_STUDENTS = "CROSS_CURRICULUM_STUDENTS";
export const ROLES_AND_PERMISSIONS = "ROLES_AND_PERMISSIONS";
export const ATTENDANCE_SETTINGS_V2_CONFIG_ID = "136957547767666416";
export const BLUEPRINT_SYNC = "BLUEPRINT_SYNC";
export const LIBRARY = "LIBRARY";
export const ROSTER_SYNC = "ROSTER_SYNC";
export const TIMETABLE_SYNC = "TIMETABLE_SYNC";
export const ATTENDANCE_SYNC = "ATTENDANCE_SYNC";

export const TODDLE_AI_MODULES = [
  {
    id: "LESSON_PLANNING_AI",
    label: "ai:lesson_planning_ai",
  },
  {
    id: "ANNOUNCEMENT_AI",
    label: "ai:announcement_ai",
  },
  {
    id: "PROGRESS_REPORT_AI",
    label: "ai:progress_report_ai",
  },
  {
    id: "PORTFOLIO_AI",
    label: "ai:portfolio_ai",
  },
  {
    id: "UNIT_PLANNING_AI",
    label: "unitPlan:curriculum_design_assistant",
  },
];

export const ADD_ON_TYPES = {
  ORGANIZATION_LEVEL: "ORGANIZATION_LEVEL",
  CURRICULUM_LEVEL: "CURRICULUM_LEVEL",
};

export const LOADING_STATES = {
  FETCHING: "FETCHING",
  SAVING: "SAVING",
};
